import { CommonModule } from '@angular/common';
import { HttpErrorResponse, HttpParams } from '@angular/common/http';
import { Component, NgModule, OnInit } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { DxButtonModule } from 'devextreme-angular';
import { DxFormModule } from 'devextreme-angular/ui/form';
import { DxLoadIndicatorModule } from 'devextreme-angular/ui/load-indicator';
import notify from 'devextreme/ui/notify';
import { pedidoMayoristaService } from 'src/app/pages/pedidoMayorista/pedidoMayoristaService.service';
import { AuthService } from '../../services/auth/auth.service';

@Component({
  selector: 'app-login-form',
  templateUrl: './login-form.component.html',
  styleUrls: ['./login-form.component.scss']
})
export class LoginFormComponent implements OnInit {

  buttonOptions = {
    text: "Acceder",
    useSubmitBehavior: true,
    width: "100%",
    type: "default"
  };
  errorMessage: string = '';
  arrProductos: any[] = [];
  loading = false;
  formData: any = {};
  public errorLogin = false;
  formToShow: 'login' | 'none' = 'none';

  constructor(
    private authService: AuthService,
    private router: Router,
    private pedidoMayoristaService: pedidoMayoristaService
    ) { }

  ngOnInit(): void {
    let params = new HttpParams();

    this.pedidoMayoristaService.getProductos(params).subscribe((data: any) => {
      this.arrProductos = data.data.filter((x:any) => (!x.ProductoExcluido && x.PrecioMayorista > 0 && x.PrecioMayorista != null && x.PrecioMayorista != 0) ) || [];
    });
  }

  async onSubmit(e: Event) {
    e.preventDefault();
    const { email, password, rememberMe } = this.formData;
    this.loading = true;


    const result = this.authService.login({email, password}, rememberMe).subscribe(res => {
      console.log(res);
      //recuperar los datos del usuario, el tipo y el menu de opciones disponibles
    }, (err) => {
      this.errorLogin = true;
      this.loading = false;
      console.error('Error de login:', err); // Para depurar en PC
       this.errorMessage = this.parseError(err);
      notify( err.status===500?'Error accediendo al server:'+err.error.Message:err.error.Message, 'error ', 5000);
    });
  }
parseError(err: any): string {
  if (err?.error?.message) return err.error.message;
  if (err?.status === 0) return 'No se pudo conectar con el servidor';
  return 'Error inesperado. Intente de nuevo.';
}
  showLoginForm() {
    this.formToShow = 'login';
  }

  showRegisterForm() {
    this.router.navigate(['/create-account']);
  }

  showChoice() {
    this.formToShow = 'none';
  }
showTiendaNubeForm(){
  window.open('https://huapango.com.ar', '_blank');
  this.formToShow = 'none';
}
}

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    DxFormModule,
    DxLoadIndicatorModule,
    DxButtonModule
  ],
  declarations: [ LoginFormComponent ],
  exports: [ LoginFormComponent ]
})
export class LoginFormModule { }
